import React from 'react'
import { Row, Col } from "antd";
import { FaHandPaper } from "react-icons/fa";
import Img from '../assets/services-img.png'
import Img1 from '../assets/icon/icon.png'
function Service() {
  return (
    <>
      <div className="container PT-5 pb-5">
        <Row gutter={[30, 25]} align="middle">
          <Col md={12}>
            <div className="main-text-loop ">
              <h4 className='text-gray-500 mb-2 text-3xl font-custom '>Digital printing Service</h4>

              <h2 className='text-4xl font-bold mb-4  font-custom leading-snug'>Why Choose Initial Global Trade</h2>
              <p className='font-custom text-gray-500'>What started as a small local venture in California has grown into a trusted name in custom T-shirt printing. We saw how people struggled to find high-quality printing services that were easy to use, transparent, and reliable — and decided to change that.</p>
              <div className="main-ul-loop flex mt-5 mb-5 items-center gap-[60px] mb-5">
                <div className="main-loop-ul ">
                  <ul>
                    <li className='font-custom mb-1 gap-2 text-[16px] flex '><img className='object-contain' src={Img1} alt="img" /> High-Quality Materials</li>
                    <li className='font-custom mb-1 gap-2  text-[16px] flex'><img className='object-contain' src={Img1} alt="img" /> Fast Turnaround</li>
                    <li className='font-custom mb-1 gap-2  text-[16px] flex '><img className='object-contain' src={Img1} alt="img" /> Easy Design Process</li>
                  </ul>
                </div>
                <div className="main-loop-ul">
                  <ul>
                    <li className='font-custom mb-1 text-[16px] flex gap-2'><img className='object-contain' src={Img1} alt="img" />High-Quality Materials</li>
                    <li className='font-custom mb-1 gap-2 text-[16px] flex'><img className='object-contain' src={Img1} alt="img" />Fast Turnaround</li>
                    <li className='font-custom mb-1 gap-2 text-[16px] flex'><img className='object-contain' src={Img1} alt="img" />Easy Design Process</li>
                  </ul>
                </div>
              </div>
              <button className='ant-btn css-dev-only-do-not-override-ac2jek ant-btn-default ant-btn-color-default ant-btn-variant-outlined relative font-custom text-lg font-semibold
 overflow-hidden border-2 border-teal-400 rounded-full
 px-6 h-[45px] transition-all duration-300 ease-in-out
 text-teal-600 bg-white hover:!bg-[#6cc5bf] hover:!border-[#000]
 hover:!text-white shadow-[6px_6px_0_0_#14b8a6]
 hover:shadow-[0px_0px_0_0_#14b8a6]
 active:shadow-[0_2px_0_0_#14b8a6]
 active:translate-y-[4px] group flex items-center '>Let’s talk — Send a message span <span><FaHandPaper /></span></button>
            </div>
          </Col>
          <Col md={12}>
            <img src={Img} alt="img" />
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Service